/* ══════════════════════════════════════════════════════════════
   FA SHIP MATRIX — single source of truth for per-product state
   availability across the site (PDP widget, collection chips,
   cart warnings, regulation-terminal product filter).
   LOCKSTEP RULE: edit this file ONLY together with the guard
   Function's BANNED_STATES/BANNED_ZIPS (favordalkz-volume-pricing/
   extensions/restricted-zips) — same discipline as the gift
   earned-map. Basis: ~/FA_state_shipping_matrix_oct2026.md.
   TO ADD A PRODUCT: one entry in PRODUCTS keyed by its Shopify
   handle. A 50-state product = { closed: [], soon: [] }.
   Updated: Oct 15, 2026 (WV + NE opened for full-spectrum → 29 ship-to states; VA + FL + MD opened for capsules → 32 for caps; VA + MD also open for quarter-scored 42 Alkz tablets → 31; guard PARTIAL_STATE_ALLOW; NY back on the 7-OH list → 20). Oct 14: WHY table added; concentrate list 16→19: +MO +OR +WV.
   ══════════════════════════════════════════════════════════════ */
window.FA_SHIP = (function () {
  var CLOSED_LAUNCH = ["AL","AR","CA","CT","DC","FL","GA","HI","IN","KS","KY","LA","MA","MD","MS","ND","OH","RI","TN","UT","VA","VT","WI"];

  var NAMES = {
    AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",
    CO:"Colorado",CT:"Connecticut",DE:"Delaware",DC:"District of Columbia",
    FL:"Florida",GA:"Georgia",HI:"Hawaii",ID:"Idaho",IL:"Illinois",
    IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",
    ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",
    MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",
    NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",
    NC:"North Carolina",ND:"North Dakota",OH:"Ohio",OK:"Oklahoma",
    OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",
    SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",
    VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"
  };

  // Keyed by Shopify product handle.
  var TABLET = { closed: CLOSED_LAUNCH, soon: [] };
  // Oct 15 2026 (Parker): 42 Alkz tablets are quarter-scored — label serving = 1/4 tablet (0.34–0.43 mg 7-OH) — so VA + MD per-serving caps pass (Passion Fruit opened Oct 15 pm — same batch as Blueberry). FL is per-gram: still closed for tablets.
  var TABLET_Q = { closed: CLOSED_LAUNCH.filter(function(x){ return x !== "VA" && x !== "MD"; }), soon: [] };
  // Concentrate 7-OH (Blue Razz / Orange Dreamsicle) — authorized in 21 states (15 no-restriction [HI removed Oct 16 2026 — emergency Schedule I order eff. Sep 22] + MO, OR, WV opened Oct 14 2026 + NY Oct 15 — S 8925-A unsigned, county ZIPs still blocked + NJ Oct 16 — S301 unsigned, last action Mar 16 2026 + SC Oct 19 — Act 35 KCPA, no cap, bars only fully synthetic; WV + NE opened for full-spectrum Oct 15 — NE concentrate still fails the 2% cap)
  // ONLY, lockstep with guard CONCENTRATE_7OH_ALLOWED_STATES. All others blocked pending DEA guidance.
  var CONC_7OH_ALLOWED = ["AK","DE","IA","ID","IL","ME","MI","MN","MO","MT","NC","NH","NJ","NM","NV","NY","OR","PA","SC","WA","WV"];
  var CONC_7OH_CLOSED = Object.keys(NAMES).filter(function(s){ return CONC_7OH_ALLOWED.indexOf(s) === -1; });
  var PRODUCTS = {
    "natures-organix-cherry":    { label: "Nature's Organix Cherry Tablets",    closed: TABLET_Q.closed, soon: TABLET_Q.soon },
    "natures-organix-grape":     { label: "Nature's Organix Grape Tablets",     closed: TABLET_Q.closed, soon: TABLET_Q.soon },
    "natures-organix-blueberry": { label: "Nature's Organix Blueberry Tablets", closed: TABLET_Q.closed, soon: TABLET_Q.soon },
    "natures-organix-passion-fruit": { label: "Nature's Organix Passion Fruit Tablets", closed: TABLET_Q.closed, soon: TABLET_Q.soon },
    "natures-alks-75mg":         { label: "Nature's Alks 75mg Capsules",        closed: CLOSED_LAUNCH.filter(function(x){ return x !== "VA" && x !== "FL" && x !== "MD"; }), soon: [] }, // VA/FL/MD (Oct 15 2026): capsules pass (0.39 mg/serving, 0.598 mg/g, 101:1, 0.56–0.71%); tablets stay closed
    "blue-razz-40mg":              { label: "Blue Razz 7-OH Tablets",             closed: CONC_7OH_CLOSED, soon: [] },
    "orange-dreamsicle-40mg-tab":  { label: "Orange Dreamsicle 7-OH Tablets",     closed: CONC_7OH_CLOSED, soon: [] },
    "vanilla-mint-40mg-tab":       { label: "Vanilla Mint 7-OH Tablets",          closed: CONC_7OH_CLOSED, soon: [] },
    "watermelon-40mg-tab":         { label: "Watermelon 7-OH Tablets",            closed: CONC_7OH_CLOSED, soon: [] },
    "vanilla-mint-25mg-tab":       { label: "Vanilla Mint 25mg 7-OH Tablets",     closed: CONC_7OH_CLOSED, soon: [] },
    "watermelon-25mg-tab":         { label: "Watermelon 25mg 7-OH Tablets",       closed: CONC_7OH_CLOSED, soon: [] }
  };
  // Unknown handles fall back to the launch zone (conservative).
  var DEFAULT = { label: "This product", closed: CLOSED_LAUNCH, soon: [] };

  // Regulation-terminal dropdown groups (one row per product family).
  var TERMINAL = [
    { key: "tablets", handle: "natures-organix-cherry",
      name: "Nature's Organix Full-Spectrum Tablets (Cherry / Grape / Blueberry / Passion Fruit)",
      note: "Full-spectrum kratom alkaloid tablets, quarter-scored (serving = 1/4 tablet). Ships to 30 states; state alkaloid caps keep them out of the rest." },
    { key: "caps75", handle: "natures-alks-75mg",
      name: "Nature's Alks 75mg Full-Spectrum Liposomal Capsules",
      note: "Ships to 31 states today. Florida, Maryland and Virginia take capsules only \u2014 tablets exceed their 1 mg per-serving / per-gram 7-OH caps." }
  ];

  // WHY (Oct 14 2026): the rule each state applies and how our products test against it. Keyed by state;
  // t = full-spectrum tablets (0.39–1.72 mg 7-OH/tablet, 0.56–0.71% of alkaloids), k = liposomal capsules
  // (0.39 mg/capsule, 0.598 mg/g), c = concentrate (33–38 mg 7-OH/tablet, ~56 mg/g). Source: docs/regulation-audit-oct13-2026
  // factchecks.json corrected rows. LOCKSTEP with the guard + PRODUCTS above.
  var SPECS = { t: "Full-spectrum tablets: 0.39–1.72 mg 7-OH per tablet, 7-OH = 0.56–0.71% of total alkaloids",
                k: "Liposomal capsules: 0.39 mg 7-OH per capsule (0.598 mg/g), 7-OH = 0.56–0.71% of total alkaloids",
                c: "7-OH tablets: 25–38 mg 7-OH per tablet, 7-OH is the dominant alkaloid" };
  var FAMILY = { "natures-organix-cherry":"t","natures-organix-grape":"t","natures-organix-blueberry":"t","natures-organix-passion-fruit":"t",
                 "natures-alks-75mg":"k","blue-razz-40mg":"c","orange-dreamsicle-40mg-tab":"c","vanilla-mint-40mg-tab":"c","watermelon-40mg-tab":"c","vanilla-mint-25mg-tab":"c","watermelon-25mg-tab":"c" };
  var WHY = {
  "AL": {
  "law": "Mitragynine and 7-OH are Schedule I (Ala. Code 20-2-23) — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "AR": {
  "law": "Mitragynine and 7-OH are Schedule I by name — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "CT": {
  "law": "Kratom leaf, extracts, mitragynine and 7-OH are state Schedule I (RCSA 21a-243-7) — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "IN": {
  "law": "Any substance containing mitragynine or 7-OH is a 'synthetic drug' / Schedule I (IC 35-48-2-4).",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "KS": {
  "law": "7-OH and mitragynine are Schedule I since Jul 1 2026 (K.S.A. 65-4105) — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "LA": {
  "law": "Act 41: any preparation containing mitragynine or 7-OH is Schedule I — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "MA": {
  "law": "105 CMR 726.003 lists the plant, mitragynine and 7-OH as Schedule I (eff. Aug 28 2026).",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "TN": {
  "law": "PC 950: any extract, derivative or preparation of kratom is prohibited (eff. Jul 1 2026).",
  "t": "Our products are leaf extracts — prohibited regardless of potency.",
  "k": "Our products are leaf extracts — prohibited regardless of potency.",
  "c": "Our products are leaf extracts — prohibited regardless of potency."
  },
  "VT": {
  "law": "Mitragynine and 7-OH are regulated (hallucinogenic) drugs — any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "WI": {
  "law": "Mitragynine and 7-OH are Schedule I (Wis. Stat. 961.14) in any quantity.",
  "t": "Scheduled or banned at any quantity — no threshold to meet.",
  "k": "Scheduled or banned at any quantity — no threshold to meet.",
  "c": "Scheduled or banned at any quantity — no threshold to meet."
  },
  "ND": {
  "law": "HB 1628: 7-OH above 0.05% by weight (0.5 mg/g) is Schedule I and retail sales are frozen.",
  "t": "Tablets exceed 0.5 mg/g — fails.",
  "k": "Capsules test 0.598 mg/g vs the 0.5 mg/g line — fails.",
  "c": "~56 mg/g vs 0.5 mg/g — fails."
  },
  "OH": {
  "law": "Board of Pharmacy rule: only leaf in 'vegetation form' is exempt; extracts and 7-OH products are Schedule I.",
  "t": "Our tablets and capsules are extracts, not raw leaf — fails.",
  "k": "Our tablets and capsules are extracts, not raw leaf — fails.",
  "c": "Our tablets and capsules are extracts, not raw leaf — fails."
  },
  "DC": {
  "law": "22-B DCMR 1201.1(h)(16) lists 7-OH as Schedule I with no threshold.",
  "t": "Every unit contains 7-OH — fails at any amount.",
  "k": "Every unit contains 7-OH — fails at any amount.",
  "c": "Every unit contains 7-OH — fails at any amount."
  },
  "CA": {
  "law": "CDPH treats all kratom and 7-OH products as adulterated under the Sherman Law (NR25-016) and says they cannot be sold online or in stores.",
  "t": "Statewide no-sale posture covers every kratom product regardless of potency.",
  "k": "Statewide no-sale posture covers every kratom product regardless of potency.",
  "c": "Statewide no-sale posture covers every kratom product regardless of potency."
  },
  "RI": {
  "law": "§11-9-13.23: delivery of kratom to consumers is prohibited; sales only at RIDOH-licensed retail locations.",
  "t": "Online delivery itself is barred, so no product can ship here.",
  "k": "Online delivery itself is barred, so no product can ship here.",
  "c": "Online delivery itself is barred, so no product can ship here."
  },
  "FL": {
  "law": "Emergency rule 2ER26-2: ≤1 mg 7-OH per gram and a mitragynine-to-7-OH ratio of at least 100:1, plus Florida label text.",
  "t": "One tablet SKU (0.39 mg) passes; the 1.36–1.72 mg SKUs are at the 1 mg/g line — blocked statewide until each SKU is verified.",
  "k": "Capsules test 0.598 mg/g and 101:1 — pass. Ships to Florida (capsules only).",
  "c": "~56 mg/g vs 1 mg/g — fails by ~56×."
  },
  "GA": {
  "law": "HB 181: ≤150 mg mitragynine per serving, ≤0.5 mg 7-OH per gram, ≤1 mg 7-OH per serving.",
  "t": "The 195.7 mg mitragynine SKU exceeds 150 mg/serving and the 1.36–1.72 mg SKUs exceed the per-gram cap — fails.",
  "k": "Capsules test 0.598 mg/g vs the 0.5 mg/g cap — fails by 20%.",
  "c": "33–38 mg per tablet vs 1 mg/serving — fails."
  },
  "KY": {
  "law": "7-OH above 400 ppm dry weight (0.4 mg/g) is Schedule I; total kratom ban Jul 1 2027.",
  "t": "Tablets exceed 0.4 mg/g — fails.",
  "k": "Capsules test 0.598 mg/g = 598 ppm vs 400 ppm — fails.",
  "c": "~56,000 ppm vs 400 ppm — fails."
  },
  "MD": {
  "law": "KCPA: 7-OH ≤2% of alkaloids, plus a 1 mg-per-serving seizure trigger (§1-323) and an FDA-recognition clause.",
  "t": "Quarter-scored tablets put 0.34–0.43 mg 7-OH in a 1/4-tablet serving — under the 1 mg trigger. Ships.",
  "k": "Capsules carry 0.39 mg per capsule — under 1 mg. Ships to Maryland (capsules only).",
  "c": "33–38 mg per tablet is 33× the 1 mg trigger — fails."
  },
  "MS": {
  "law": "HB 1077: 7-OH ≤1% of alkaloids AND ≤0.5 mg 7-OH per container.",
  "t": "Ratio passes (0.56–0.71%) but every container holds more than 0.5 mg total 7-OH — fails.",
  "k": "Ratio passes (0.56–0.71%) but every container holds more than 0.5 mg total 7-OH — fails.",
  "c": "Ratio passes (0.56–0.71%) but every container holds more than 0.5 mg total 7-OH — fails."
  },
  "UT": {
  "law": "SB45: kratom 'extract' form barred and 7-OH capped at 0.4% of total alkaloids.",
  "t": "Tablets are an extract and test 0.56–0.71% of alkaloids vs 0.4% — fails twice.",
  "k": "Capsules are an extract and test 0.56–0.71% vs 0.4% — fails twice.",
  "c": "7-OH is the dominant alkaloid — fails."
  },
  "VA": {
  "law": "2026 kratom law: 7-OH ≤1 mg per serving AND ≤1% of total alkaloids.",
  "t": "Ratio passes (0.56–0.71%); quarter-scored tablets put 0.34–0.43 mg 7-OH in a 1/4-tablet serving — under the 1 mg cap. Ships.",
  "k": "Capsules carry 0.39 mg per capsule and 0.56–0.71% of alkaloids — pass both tests. Ships to Virginia (capsules only).",
  "c": "33–38 mg per tablet vs 1 mg — fails."
  },
  "NE": {
  "law": "KCPA: 7-OH ≤2% of alkaloids, no synthesized alkaloids, and every product must be registered with the state before sale.",
  "t": "0.56–0.71% of alkaloids — passes the 2% cap. Ships to Nebraska.",
  "k": "0.56–0.71% of alkaloids — passes the 2% cap. Ships to Nebraska.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "WV": {
  "law": "SB 985 / 61CSR30: ≤10 mg 7-OH per dose, products limited to simple leaf forms, WVDA registration required.",
  "t": "0.39–1.72 mg per tablet passes the 10 mg cap. Ships to West Virginia.",
  "k": "0.39 mg per capsule passes the 10 mg cap. Ships to West Virginia.",
  "c": "Quarter-scored 33–38 mg tablets are under 10 mg per dose — ships through Restricted Access until the federal order takes effect."
  },
  "AZ": {
  "law": "KCPA (36-795.02): 7-OH ≤2% of total alkaloids, no synthetic alkaloids, 21+.",
  "t": "0.56–0.71% of alkaloids vs 2% — passes.",
  "k": "0.56–0.71% of alkaloids vs 2% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "CO": {
  "law": "Daniel Bregger Act (6-1-740): 7-OH ≤2% of total alkaloids, no synthesized alkaloids, 21+.",
  "t": "0.56–0.71% of alkaloids vs 2% — passes.",
  "k": "0.56–0.71% of alkaloids vs 2% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "SD": {
  "law": "KCPA: 7-OH ≤2% of the alkaloid fraction, 21+.",
  "t": "0.56–0.71% of alkaloids vs 2% — passes.",
  "k": "0.56–0.71% of alkaloids vs 2% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "TX": {
  "law": "KCPA: 7-OH ≤2% of total alkaloids, 21+.",
  "t": "0.56–0.71% of alkaloids vs 2% — passes.",
  "k": "0.56–0.71% of alkaloids vs 2% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "WY": {
  "law": "KCPA (35-7-2202): 7-OH ≤2% of alkaloids, no synthesized alkaloids, 21+.",
  "t": "0.56–0.71% of alkaloids vs 2% — passes.",
  "k": "0.56–0.71% of alkaloids vs 2% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 2% cap."
  },
  "OK": {
  "law": "KCPA: 7-OH ≤1% of total alkaloids, mitragynine must be the dominant alkaloid, 21+.",
  "t": "0.56–0.71% of alkaloids vs 1% — passes.",
  "k": "0.56–0.71% of alkaloids vs 1% — passes.",
  "c": "7-OH is the dominant alkaloid — fails the 1% cap."
  },
  "OR": {
  "law": "KCPA: 21+, labeling and processor rules; no 7-OH cap in force.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state cap — ships through Restricted Access."
  },
  "NV": {
  "law": "KCPA (NRS 597.998): 21+ and labeling; no 7-OH cap.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "DE": {
  "law": "KCPA (16 Del. C. Ch. 30U): 21+ and no child-directed marketing; no 7-OH cap.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "SC": {
  "law": "Act 35: 21+, labeling, and a bar on fully synthetic 7-OH; no numeric cap.",
  "t": "No cap to test; natural extract — ships.",
  "k": "No cap to test; natural extract — ships.",
  "c": "No 7-OH cap; Act 35 bars only fully synthetic alkaloids — ships through Restricted Access until the federal order."
  },
  "NY": {
  "law": "PHL 1399-xx: 21+ sales; S8925-A (7-OH ≤2% of alkaloids or ≤1 mg/serving) awaits the Governor; Nassau and Dutchess county rules.",
  "t": "No state cap in force — ships to most addresses; Nassau and Dutchess county ZIPs excluded.",
  "k": "No state cap in force — ships to most addresses; Nassau and Dutchess county ZIPs excluded.",
  "c": "No cap in force (S 8925-A is unsigned) — ships through Restricted Access; Nassau and Dutchess county ZIPs excluded."
  },
  "NJ": {
  "law": "No kratom law in force; S301 (zero-threshold 7-OH scheduling) is pending.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No cap in force (S301 has not passed either chamber) — ships through Restricted Access. Withdrawn the day S301 is signed."
  },
  "MO": {
  "law": "No state kratom cap; Attorney General consumer-protection posture on 7-OH; local rules in Independence, Excelsior Springs.",
  "t": "No cap to test — ships (listed local ZIPs excluded).",
  "k": "No cap to test — ships (listed local ZIPs excluded).",
  "c": "No statute — ships through Restricted Access (St. Joseph and Excelsior Springs ZIPs excluded)."
  },
  "ID": {
  "law": "No state kratom law; county/city delivery bans in Bonneville, Bingham and Coeur d'Alene.",
  "t": "No cap to test — ships outside the listed local ZIPs.",
  "k": "No cap to test — ships outside the listed local ZIPs.",
  "c": "No state restriction — ships outside the listed local ZIPs until the federal order."
  },
  "IL": {
  "law": "No state kratom law; several municipal bans (Madison County corridor, Bloomington and others).",
  "t": "No cap to test — ships outside the listed local ZIPs.",
  "k": "No cap to test — ships outside the listed local ZIPs.",
  "c": "No state restriction — ships outside the listed local ZIPs until the federal order."
  },
  "WA": {
  "law": "No state kratom law; Mount Vernon and Bellingham distribution bans.",
  "t": "No cap to test — ships outside the listed local ZIPs.",
  "k": "No cap to test — ships outside the listed local ZIPs.",
  "c": "No state restriction — ships outside the listed local ZIPs until the federal order."
  },
  "AK": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "HI": {
  "law": "Emergency scheduling order (HRS § 329-11(e), effective September 22, 2026): any kratom product with more than 0.05% 7-OH by weight or more than 1 mg of 7-OH per unit is Schedule I.",
  "t": "Tablets carry 0.39–1.72 mg 7-OH per unit (0.05–0.23% by weight) — above the limit. Does not ship.",
  "k": "Capsules carry 0.39 mg per capsule but 0.06% 7-OH by weight — above the 0.05% limit. Does not ship.",
  "c": "7-OH tablets are far above both limits. Does not ship."
  },
  "IA": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "ME": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "MI": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "MN": {
  "law": "No state law restricts kratom or 7-OH (21+ purchase age).",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "MT": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "NC": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "NH": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "NM": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  },
  "PA": {
  "law": "No state law restricts kratom or 7-OH.",
  "t": "No cap to test — ships.",
  "k": "No cap to test — ships.",
  "c": "No state 7-OH restriction — ships until the federal order takes effect."
  }
  };
  function whyFor(handle, st) {
    var f = FAMILY[handle] || "t"; var w = WHY[st];
    if (!w) return { law: "", verdict: "", spec: SPECS[f] };
    return { law: w.law, verdict: w[f], spec: SPECS[f], family: f };
  }
  function get(handle) { return PRODUCTS[handle] || DEFAULT; }
  function statusFor(handle, st) {
    var p = get(handle);
    if (p.closed.indexOf(st) === -1) return "ships";
    if (p.soon && p.soon.indexOf(st) !== -1) return "soon";
    return "blocked";
  }
  function shipCount(handle) { return 51 - get(handle).closed.length; }
  function getState() { try { return localStorage.getItem("fa_state") || ""; } catch (e) { return ""; } }
  function setState(v) { try { localStorage.setItem("fa_state", v); } catch (e) {} }

  return { CLOSED_LAUNCH: CLOSED_LAUNCH, NAMES: NAMES, PRODUCTS: PRODUCTS, TERMINAL: TERMINAL, WHY: WHY, SPECS: SPECS, whyFor: whyFor,
           get: get, statusFor: statusFor, shipCount: shipCount, getState: getState, setState: setState };
})();
